module.exports = __webpack_public_path__ + "static/media/eye.5f64183d.svg";